import { SET_CAMPAIGN_PICKER_SORTING } from './actionTypes';

const setCampaignPickerSorting = sortOption => ({
    type: SET_CAMPAIGN_PICKER_SORTING,
    payload: sortOption,
});

export default setCampaignPickerSorting;
